import React from 'react';
import styled from '@emotion/styled';

type Props = {
  top: number;
  left: number;
  glowStart?: number;
};

const Star = ({ top, left, glowStart = 0 }: Props) => {
  return (
    <ImageStar
      src='/images/star2.png'
      top={top}
      left={left}
      glowStart={glowStart}
    />
  );
};
const ImageStar = styled.img<{ top: number; left: number; glowStart: number }>`
  position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  width: fit-content;
  height: fit-content;

  @keyframes glow {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  animation: 0.8s linear infinite alternate glow;
  animation-delay: ${(props) => props.glowStart}ms;
`;
export default Star;
